<div class="px-24 py-24 m-w-550">
    <div class="font-size-16" fusePerfectScrollbar fxLayout="column">
        <div class="warning-text pb-8">
            {{ "WARNING" | translate }}
        </div>
        <div fxLayout="column">
            {{ BodyText | translate }}
        </div>
    </div>
    <div class="mt-24" fxLayout="row" fxLayoutAlign="space-between center">

        <!--No button section-->
        <div *ngIf="ButtonNoText">
            <button appGhostButton mat-button (click)="cancel()">
                <mat-icon>close</mat-icon>
                <span>{{ ButtonNoText | translate }}</span>
            </button>
        </div>


        <div class="yes-button ml-16" >
            <button mat-button aria-label="Save" (click)="submitForm(true)">
                {{ ButtonRejectWithMail | translate }}
            </button>
        </div>

        <!--Yes button section-->
        <div class="ml-16">
            <button mat-button appPrimaryButton (click)="submitForm(false)">
                {{ ButtonRejectText | translate }}
            </button>
        </div>


    </div>
</div>
